import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LanguageSelector } from '../../components/LanguageSelector';
import { PasswordChangeForm } from '../../components/PasswordChangeForm';

/**
 * Reimpostazione della password dal link ricevuto per email (FILO-70):
 * `/reset-password?ticket=…`, composto dal backend in /user/resetPassword.
 *
 * Basta il ticket: l'istanza la ricava il backend dal ticket, quindi la pagina non la deduce
 * dall'host e il link vale anche su un host IP. Campi e chiamata sono quelli di
 * {@link PasswordChangeForm}, in modalità ticket; questa pagina è solo la cornice, con lo stesso
 * aspetto della login.
 *
 * Un link senza ticket (copiato a metà, aperto a mano) non mostra il form ma un rimando alla
 * richiesta di un link nuovo. Un ticket scaduto o già usato lo dice il backend al salvataggio.
 */
export function ResetPasswordPage() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [done, setDone] = useState(false);

  const ticket = searchParams.get('ticket') ?? '';

  return (
    <div className="login-page">
      <div className="login-brand">
        <img src="/logo.svg" alt={t('brand.name')} className="logo" width="100" />
        <h1>
          <span className="login-brand__accent">D'vel</span> CRM
        </h1>
        <p className="login-brand__tagline">{t('brand.tagline')}</p>
      </div>
      <LanguageSelector />
      <div className="login-form">
        <h2 className="text-center text-lg mb-xl">{t('auth.resetPasswordTitle')}</h2>

        {done ? (
          <p className="text-center mb-lg">{t('auth.resetPasswordDone')}</p>
        ) : ticket ? (
          <PasswordChangeForm ticket={{ ticket }} fullWidthSubmit onSuccess={() => setDone(true)} />
        ) : (
          <p className="text-center mb-lg">
            {t('auth.resetPasswordInvalidLink')}{' '}
            <Link to="/forgot-password" className="detail-back-link">{t('auth.resetPasswordRequestNew')}</Link>
          </p>
        )}

        <p className="text-center mt-lg text-sm">
          <Link to="/login" className="text-muted detail-back-link">{t('auth.backToLogin')}</Link>
        </p>
      </div>
    </div>
  );
}
